import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type StoreState = {
  addStoreVerify?: AddStoreVerifyType;
  dataAllStore: AllStoreType[];
  pagination: PaginationAPI;
  totalElements?: number;
  hasInitialLoad: boolean; // Track if we've loaded data at least once
  hasEverHadData: boolean; // Track if account has ever had stores
  dataDetailStore?: DetailStoreType;
};

export const storeInitialState: StoreState = {
  dataAllStore: [],
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
  hasInitialLoad: false,
  hasEverHadData: false,
};

const slice = createSlice({
  name: 'store',
  initialState: storeInitialState,
  reducers: {
    setDataAddStoreVerify(
      state,
      action: PayloadAction<{
        data: AddStoreVerifyType;
      }>,
    ) {
      const { payload } = action;
      state.addStoreVerify = payload.data;
    },

    setListStoreAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: AllStoreType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllStore = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
      state.hasInitialLoad = true; // Mark that we've loaded data

      // If we have data now, mark that account has had data
      if (payload.data.length > 0) {
        state.hasEverHadData = true;
      }
    },
    setDetailStoreAction(state, { payload }: PayloadAction<{ data: DetailStoreType }>) {
      state.dataDetailStore = payload.data;
    },
  },
});

export const { setDataAddStoreVerify, setListStoreAction, setDetailStoreAction } = slice.actions;
export default slice.reducer;
